"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
const react_1 = __importDefault(require("react"));
const sds_1 = require("@squiz/sds");
const ErrorIcon_1 = require("../Icons/ErrorIcon");
const Error = ({ infoText, buttonText, onReset }) => {
    return (react_1.default.createElement("div", { className: "error", role: "alert" },
        react_1.default.createElement(sds_1.SdsIcon, { svg: react_1.default.createElement(ErrorIcon_1.ErrorIcon, null), classes: 'error__alert-icon' }),
        react_1.default.createElement(sds_1.SdsText, { fontSize: sds_1.SdsTextSize.Large, fontWeight: sds_1.SdsTextWeight.Regular, text: infoText, classes: 'error__info-text', customTag: "div" }),
        react_1.default.createElement(sds_1.Button, { format: sds_1.BUTTON_FORMAT_SOFT, key: 0, onClick: onReset, text: buttonText, theme: sds_1.BUTTON_THEME_DEFAULT, icon: sds_1.ICON_REFRESH, iconPosition: 'left' })));
};
exports.Error = Error;
